import offlineDb from './db';
import { TEMP_PREFIX, findTempIds, remapTempIds } from './tempIdText';

export { findTempIds, remapTempIds };

export function generateTempId(entityType) {
  return `${TEMP_PREFIX}${entityType}_${crypto.randomUUID()}`;
}

export function isTempId(id) {
  return typeof id === 'string' && id.startsWith(TEMP_PREFIX);
}

export async function registerMapping(tempId, serverId) {
  await offlineDb.idMappings.put({ tempId, serverId, createdAt: Date.now() });
}

export async function resolveId(idOrTempId) {
  if (!isTempId(idOrTempId)) return idOrTempId;
  const mapping = await offlineDb.idMappings.get(idOrTempId);
  return mapping?.serverId || idOrTempId;
}

/**
 * Rewrite mapped placeholders in a request body and report the ones that have
 * no mapping yet (their create has not synced). Same substitution the sync
 * queue applies on replay, for writes that go out live after a reconnect.
 */
export async function resolveTempIdsInText(text) {
  if (typeof text !== 'string' || !text.includes(TEMP_PREFIX)) return { text, unresolved: [] };
  const mappings = await offlineDb.idMappings.toArray();
  const resolved = remapTempIds(text, mappings);
  return { text: resolved, unresolved: findTempIds(resolved) };
}

export async function resolveAllMappings() {
  const mappings = await offlineDb.idMappings.toArray();
  const map = {};
  for (const m of mappings) {
    map[m.tempId] = m.serverId;
  }
  return map;
}
